export function normalizeForSearch(value) {
    return value
        .toUpperCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[-'’",]/g, " ")
        .replace(/\s+/g, " ");
}



// WEBPACK FOOTER //
// src/services/normalizer.js